import React from 'react';
export function Footer() {
  return <footer className="border-t border-brand-beigeDeep bg-brand-beige px-4 py-6 text-center text-[11px] font-medium leading-relaxed text-brand-text sm:px-6" data-id="element-65">
      <p className="mx-auto max-w-xl" data-id="element-66">
        © 2026 DANCE PRO™ — Alle Rechte vorbehalten.
        <br data-id="element-67" />
        <br data-id="element-68" />
        Die auf dieser Website bereitgestellten Inhalte dienen ausschließlich zu
        pädagogischen Zwecken und sind als professionelle Unterrichtsressource
        für Tanzlehrer konzipiert. Sie ersetzen nicht das individuelle
        pädagogische Urteilsvermögen, tanzstilspezifische
        Unterrichtsentscheidungen oder die Standards deiner Tanzschule, deines
        Vereins oder deiner Institution. Wende stets dein professionelles
        Fachwissen an und stelle das Wohlbefinden und die Sicherheit deiner
        Schüler in den Vordergrund.
      </p>
      <nav aria-label="Rechtliche Informationen" className="mt-4 flex justify-center gap-2 font-bold uppercase tracking-wide text-brand-burgundy" data-id="element-69">
        <a href="#" className="hover:text-brand-rose" data-id="element-70">
          Impressum
        </a>
        <span data-id="element-71">·</span>
        <a href="#" className="hover:text-brand-rose" data-id="element-72">
          Datenschutzerklärung
        </a>
        <span data-id="element-73">·</span>
        <a href="#" className="hover:text-brand-rose" data-id="element-74">
          Kontakt
        </a>
      </nav>
    </footer>;
}